let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("HLeeR")).then(() => parcelRequire('im18V'));